import { render } from "./addUserView.vue?vue&type=template&id=012714f8&scoped=true"
import script from "./addUserView.vue?vue&type=script&lang=js"
export * from "./addUserView.vue?vue&type=script&lang=js"

import "./addUserView.vue?vue&type=style&index=0&id=012714f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012714f8"]])

export default __exports__